import React from 'react';

import { useGeneralSurveyStatusUpdate } from '@occc-app/dataAccessLayer/survey/mutations';
import { GeneralSurveyStatusUpdateMutationOptions, SurveyStatus } from '@occc/graphql';
import { snackbar } from '@occc-app/design-system';

import { messages } from '../messages';

type UseArchiveGeneralSurveyProps = {
  onCompleted?: () => void;
  refetchQueries?: GeneralSurveyStatusUpdateMutationOptions['refetchQueries'];
};

export const useArchiveGeneralSurvey = ({
  onCompleted,
  refetchQueries,
}: UseArchiveGeneralSurveyProps) => {
  const onArchiveError = React.useCallback(() => {
    snackbar.error(messages.archiveError);
  }, []);

  const onArchiveCompleted = React.useCallback(() => {
    snackbar.success(messages.archiveSuccess);
    onCompleted?.();
  }, [onCompleted]);

  const [updateGeneralSurveyStatus, { loading }] = useGeneralSurveyStatusUpdate({
    onCompleted: onArchiveCompleted,
    onError: onArchiveError,
    refetchQueries,
  });

  const archiveSurvey = React.useCallback(
    (surveyUuid: string) => {
      updateGeneralSurveyStatus({
        variables: {
          input: {
            uuid: surveyUuid,
            status: SurveyStatus.Archived,
          },
        },
      });
    },
    [updateGeneralSurveyStatus],
  );

  return [archiveSurvey, loading] as const;
};
